<template>
  <div id="removeclass">
  <modal
      :modal-id="modalId"
      :title="modalTitle"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader"/>
      <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="addUrl"
      >
        <div class="form-group row align-items-center">
          <label class="col-sm-4 mb-0">{{ $t("report_title") }}</label>
          <app-input
              class="col-sm-8"
              type="text"
              :placeholder="$t('report_title')"
              v-model="inputs.title"
              :required=true

          />
        </div>

        <div class="form-group row align-items-center">
          <label class="col-sm-4 mb-0">{{ $t("report_description") }}</label>
          <app-input
              class="col-sm-8"
              type="text"
              :placeholder="$t('short_description')"
              v-model="inputs.description"
              :required=true
          />
        </div>

        <div class="form-group row align-items-center" v-if="hideCompanyList == true">
          <label class="col-sm-4 mb-0">{{ $t("select_company") }}</label>
          <app-input
              class="col-sm-8"
              type="search-select"
              :placeholder="$t('select_company')"
              :list="companies"
              v-model="company_id"
              :required=true
          />
        </div>
        <div class="form-group row align-items-center" v-if="hideUserList == true">
          <label class="col-sm-4 mb-0">{{ $t("select_users") }}</label>
          <app-input
              class="col-sm-8"
              type="multi-select"
              :placeholder="$t('select_users')"
              :list="users"
              v-model="meta.users"
          />
        </div>

        <div class="form-group row align-items-center">
          <label class="col-sm-4 mb-0">{{ $t("select_report_type") }}</label>
          <app-input
              class="col-sm-8"
              type="search-select"
              :placeholder="$t('select_report_type')"
              :list="reportTypes"
              v-model="meta.reportType"
              :required=true
          />
        </div>
      </form>
    </template>
  </modal>
</div>
</template>

<script>
import {FormMixin} from "../../../../core/mixins/form/FormMixin.js";
import {ModalMixin} from "../../../Mixins/ModalMixin";
import * as actions from "../../../Config/ApiUrl";
import {
  axiosPost,
  axiosDelete,
  axiosGet,
} from "../../../Helpers/AxiosHelper";
import AppLibrary from "../../../Helpers/AppLibrary";

export default {
  name: "AddReport",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      hideCompanyList: true,
      hideUserList: true,
      company_id: '',
      documentCategories: [],
      subCategory: [],
      uploadedFiles: [],
      addUrl: actions.COMPANY_REPORTS_SUBMIT,
      preloader: false,
      title: '',
      submitCompanyReport: actions.SUBMIT_COMPANY_REPORT,
      description: '',
      selectedCompany: '',
      companies: [], // Example companies
      users: [],
      fromDate: '',
      toDate: '',
      selectedReportType: '',
      reportTypes: [
        {id: 'task', value: 'Task Reports'},
        {id: 'document_report', value: 'Document Reports'},
        {id: 'form_submission_report', value: 'Form Submission Reports'},
        {id: 'user_report', value: 'User Reports'},
      ],
      inputs: {},
      modalTitle: 'Add Report',
      modalId: "add-report-modal",
      meta: {
        users: [],
      },
    }
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      // this.addUrl = actions.MYDOCUMENT_UPDATE;
      // this.preloader = true;
    }
    this.getCompanies();
  },
  watch: {
    category_id() {
      let category_id = this.category_id
      this.getDocumentFields(category_id);

      //Sub CAtegory
      this.getSubCategory(category_id);
    },
    subcategory_id() {
      let subcategory_id = this.subcategory_id
      this.getDocumentFields(subcategory_id);
    },
    company_id() {
      this.getCompanyUsers();
    },
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
    },
    submit() {

      if (this.company_id != '') {
          this.meta.company_id = this.company_id;
      }
      // if(this.meta.users.length > 0) {

      // }
      // else {

      // }
      this.inputs.meta = this.meta;
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
      this.closeModal();
    },
    afterError(response) {
      this.$toastr.e(response.data.message);
    },
    getCompanies() {
    // axiosGet(actions.DOCUMENT_CATEGORIES)
    //     .then((res) => {
    //       this.documentCategories = res.data;
    //     })
    //     .catch((error) => {
    //       this.$toastr.e(error);
    //     })
    //     .finally(() => {
    //     });
      axiosGet(actions.SEARCH_SELECT_COMPANY_NAME).then((response) => {
          this.companies = response.data;
      });
    },
    getCompanyUsers() {
      var id = this.company_id;
      axiosGet(actions.FILTER_COMPANY_USERS + '/' + id)
          .then((res) => {
            this.users = res.data;
          })
          .catch((error) => {
            this.$toastr.e(error);
          })
          .finally(() => {
          });
    },
    checkIsCompanyAdmin() {
      // console.log(this.userRole.company_id);
      if (this.userRole.company_id != 1 && this.userRole.is_company_admin == 1) {
          this.hideCompanyList = false;
          this.company_id = this.userRole.company_id;
          this.getCompanyUsers();
      }
      else if(this.userRole.is_company_admin == 0) {
          this.hideCompanyList = false;
          this.hideUserList = false;

          this.company_id = this.userRole.company_id;
          this.meta.users = [this.userRole.id];
      }
      else if(this.userRole.company_id == 1 && this.userRole.is_company_admin == 1) {
          this.hideCompanyList = true;
          this.hideUserList = true;
      }
  }
  },
  mounted() {
    this.checkIsCompanyAdmin();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
